import React from 'react';
import { Link } from 'react-router-dom';

const API_BASE = 'https://api.zitotrontech.com';

function AgentoSuccessPage() {
  return (
    <div className="agento-page">
      <nav className="agento-nav">
        <div className="agento-nav-inner">
          <Link to="/" className="agento-nav-brand">ZitotronTech</Link>
          <div className="agento-nav-links">
            <Link to="/agento">Agento</Link>
          </div>
        </div>
      </nav>

      <section className="agento-success">
        <div className="container">
          <div className="agento-success-card">
            <div className="agento-success-check">[OK]</div>
            <h1>You're subscribed!</h1>
            <p className="agento-success-message">Your license key has been emailed to you.</p>
            <div className="agento-success-instructions">
              <h2>Get started</h2>
              <ol>
                <li>Open Agento</li>
                <li>Paste your license key</li>
                <li>You're all set</li>
              </ol>
            </div>

            <div className="agento-success-downloads">
              <h2>Download Agento</h2>
              <div className="agento-success-download-buttons">
                <a href="#" className="agento-btn-primary">Download for Linux (AppImage)</a>
                <span className="agento-download-coming">Windows -- coming soon</span>
                <span className="agento-download-coming">Mac -- coming soon</span>
              </div>
            </div>

            <div className="agento-success-manage">
              <a href={`${API_BASE}/v1/portal`} className="agento-btn-outline">
                Manage your subscription
              </a>
            </div>
          </div>
        </div>
      </section>

      <footer className="agento-footer">
        <div className="container">
          <div className="agento-footer-content">
            <p>&copy; 2026 Zito Tron Tech LLC. All rights reserved.</p>
            <div className="agento-footer-links">
              <Link to="/terms">Terms</Link>
              <Link to="/privacy">Privacy</Link>
              <Link to="/agento/eula">EULA</Link>
              <a href="mailto:support@zitotrontech.com">support@zitotrontech.com</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default AgentoSuccessPage;
